import isNull from 'lodash/isNull'
import isArray from 'lodash/isArray'
import isObject from 'lodash/isObject'
import indexOf from 'lodash/indexOf'
import keyBy from 'lodash/keyBy'
import toArray from 'lodash/toArray'

export const interpolateHeight = ({ items, activeArray, iter = 1, key = 'children' }) => {
  let amt_children = 0;
  const activeIndex = activeArray[iter - 1];

  if (iter <= activeArray.length && !isNull(activeIndex) && items[activeIndex][key]) {
    amt_children = items.length + interpolateHeight({
        items: items[activeIndex][key],
        activeArray,
        iter: iter + 1,
        key,
      });
    return amt_children;
  }
  return isArray(items) ? items.length : 0;
};

export const addItemToArray = (array = [], item, index = array.length) => {
  return [...array.slice(0, index), item, ...array.slice(index)];
};

export const addMultipleItemsToArray = (array = [], items, index = array.length) => {
  return [...array.slice(0, index), ...items, ...array.slice(index)];
};

export const updateItemArrayByIndex = (array, index, updateItemCallback) => array.map((item, i) => {
  if (i === index) {
    return updateItemCallback(item);
  }
  return item;
});

export const updateItemArrayByKey = (array, key, value, updateItemCallback) => array.map((item, i) => {
  if (item[key] === value) {
    return updateItemCallback(item);
  }
  return item;
});

export const mergeArray = (key, arr1, arr2) => {
  return toArray({
    ...keyBy(arr1, key),
    ...keyBy(arr2, key),
  })
}

export const removeItemArrayByIndex = (array, index) => {
  if (index < 0 || index > array.length - 1) {
    return console.log('index should < array.length');
  }
  return [...array.slice(0, index), ...array.slice(index + 1)];
};

export const removeItemArrayById = (array, id, key = 'id') => array.filter((item) => isObject(item) ? item[key] !== id : item !== id);

export const moveBefore = (array, index) => {
  // index = current index of item that will be moved
  if (index > 0) {
    return [...array.slice(0, index - 1), array[index], array[index - 1], ...array.slice(index + 1)];
  }
  return array;
};

export const moveAfter = (array, index) => {
  // index = current index of item that will be moved
  if (index < array.length - 1) {
    return [...array.slice(0, index), array[index + 1], array[index], ...array.slice(index + 2)];
  }
  return array;
};

export const moveBeforeById = (array, id) => moveBefore(array, indexOf(array, id))
export const moveAfterById = (array, id) => moveAfter(array, indexOf(array, id))


// WEBPACK FOOTER //
// ./src/helpers/arrayHelpers.js